import { IconButton, Typography } from '@mui/material';
import { Column, Row, Spacer } from '../../../components';
import { Svgs } from '../../../assets/svg';
import { t } from 'i18next';

interface DrawerHeaderProps {
  isMobile: boolean;
  pricebookName: string;
  setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  logo: string;
  logoSize?: string;
}

const DrawerHeader: React.FC<DrawerHeaderProps> = ({
  isMobile,
  pricebookName,
  setDrawerOpen,
  logo,
  logoSize,
}) => (
  <Row
    style={{
      marginBottom: isMobile ? '10px' : undefined,
      alignItems: isMobile ? 'center' : undefined,
    }}>
    <Column style={{ width: isMobile ? '100%' : '90%' }}>
      {!isMobile && (
        <Typography mb={1} color='secondary' variant='p14'>
          {t('3NickelsPackages')}
        </Typography>
      )}
      <Typography color='primary' variant={isMobile ? 'p24Bold' : 'p30Bold'}>
        {pricebookName}
      </Typography>
      {!isMobile && <Spacer height='xxs' />}
    </Column>
    {isMobile ? (
      <IconButton onClick={() => setDrawerOpen(false)}>
        <Svgs.IconNavAlertDefault />
      </IconButton>
    ) : (
      <img src={logo} alt='logo' style={{ height: logoSize ?? '50px' }} />
    )}
  </Row>
);

export default DrawerHeader;
